const COLLECTION_STALE_AFTER_HOURS = 24;
const COLLECTION_STALE_BEFORE_DAYS = 30;

module.exports = {
  COLLECTION_STALE_AFTER_HOURS,
  COLLECTION_STALE_BEFORE_DAYS,
};
